import { ContentCategory } from '../models/content-category.model';

export const CONTENT_CATEGORIES: ContentCategory[] = [
{
  icon: '📚',
    title: 'Curriculum Management',
  description: 'Complete curriculum planning and management tools for all educational levels and subjects with standards alignment.',
  items: 500,
  levels: 'All'
},
{
  icon: '📝',
    title: 'Assessment Tools',
  description: 'Comprehensive assessment and evaluation tools for continuous student progress monitoring and feedback.',
  items: 200,
  levels: '12+'
},
{
  icon: '🎯',
    title: 'Learning Resources',
  description: 'Rich library of educational resources, interactive materials, and multimedia content for engaging learning.',
  items: 1000,
  levels: 'All'
},
{
  icon: '📊',
    title: 'Analytics & Reports',
  description: 'Advanced analytics and reporting capabilities for data-driven educational decisions and insights.',
  items: 100,
  levels: 'Admin'
}
];
